import React, { useState } from 'react'
import { Button } from 'react-bootstrap'

import { Modal } from 'react-rainbow-components'
import { useHistory } from 'react-router'
import { createShortName } from '../helpers'
import { User } from '../types/FirestoreTypings'

export default function ModalWHeader({ leaders, date }: { leaders: User[]; date?: string }) {
  const [isOpen, setIsOpen] = useState(false)
  let history = useHistory()

  function handleOnClick(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault()
    return setIsOpen(true)
  }

  function handleOnClose() {
    return setIsOpen(false)
  }

  return (
    <div className='rainbow-m-bottom_xx-large rainbow-p-bottom_xx-large'>
      <div className='rainbow-p-bottom_xx-large rainbow-m-bottom_xx-large'>
        <Button className='more-personel-btn' onClick={handleOnClick}>
          {leaders.length}
        </Button>
      </div>

      <Modal isOpen={isOpen} onRequestClose={handleOnClose} title={`Lineup ${date ? date : ''}`}>
        {leaders
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((leader) => (
            <div className='modal-leader' onClick={() => history.push(`/profile/${leader.uid}`)} style={{ cursor: 'pointer' }} key={leader.uid}>
              <img
                src={leader.image || 'https://png.pngtree.com/png-vector/20190307/ourlarge/pngtree-vector-add-user-icon-png-image_762930.jpg'}
                alt={leader.name}
              />
              <div>{createShortName(leader.name)} </div>
            </div>
          ))}
      </Modal>
    </div>
  )
}
